import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GenericGridComponent } from '../../../../common/components/generic-grid/generic-grid.component';
import { LoadingService } from '../../../../common/components/loading/loading.service';
import { MultipleRolSelectorComponent } from '../../../../common/components/multiple-rol-selector/multiple-rol-selector.component';
import { AlertifyService } from '../../../../common/services/alertify.service';
import { LocalData } from '../../../../models/LocalData';
import { PermissionType } from '../../../../models/PermissionType';
import { RolPermissionVM } from '../../../../models/view-models';
import { RolPermissionService } from '../../../../services/rol-permission.service';
import { RolService } from '../../../../services/rol.service';

@Component({
  selector: 'app-api-endpoints',
  templateUrl: './api-endpoints.component.html',
  styleUrls: ['./api-endpoints.component.scss']
})
export class ApiEndpointsComponent implements OnInit {

  permissions: RolPermissionVM[] = [];
  permission: RolPermissionVM;
  entityForm: FormGroup;
  showForm: boolean = false;
  isEdition: boolean = false;

  @ViewChild("grid", { read: GenericGridComponent, static: false })
  public grid: GenericGridComponent;

  @ViewChild("rolSelector", { read: MultipleRolSelectorComponent, static: false })
  public rolSelector: MultipleRolSelectorComponent;

  @ViewChild("name") name: ElementRef;
  @ViewChild("code") code: ElementRef;

  disabledAddButton: boolean = false;
  routeName: string = "";

  constructor(private permissionService: RolPermissionService,
    private fb: FormBuilder,
    private rolService: RolService,
    private alertify: AlertifyService,
    private loading: LoadingService) { }


  ngAfterViewInit(): void {
    this.loadData();
  }

  ngOnInit(): void {
    this.initForm();
    this.rolService.loadAndSaveData();
  }

  initForm() {
    this.entityForm = this.fb.group({
      Code: ['', [Validators.required, Validators.minLength(2)]],
      Name: ['', [Validators.required, Validators.minLength(2)]],
      Method: ['', [Validators.required, Validators.minLength(2)]],
    });
  }

  loadData() {
    this.loading.show();
    this.permissionService.getEndpointPermissions()
      .subscribe((response: RolPermissionVM[]) => {
        if (response) {
          response.forEach(p => {
            p.Roles = this.rolService.getRolNames(p.RolCodes);
          });
          this.permissions = response;
        }
        this.setGridOptions();
        this.loading.hide();
      }, (err) => {
        this.setGridOptions();
        this.loading.hide();
      });
  }

  setGridOptions() {
    this.grid.setData(this.permissions);
    this.grid.options.toolbarTitle = "Permisos";
    this.grid.options.hideActionButtons = true;
    this.grid.options.paging = false;
    this.grid.options.rowClick = true;
    this.grid.columns = [
      { field: "Code", title: "Código" },
      { field: "Name", title: "Nombre" },
      { field: "Method", title: "Método" },
      { field: "Roles", title: "Roles" },
    ];
    this.grid.setGridOptions();
  }

  setFormVisibility = () => this.showForm = !this.showForm;

  addNew() {
    this.isEdition = false;
    this.setFormVisibility();
    setTimeout(() => {
      this.code.nativeElement.focus();
    }, 0);
  }

  isValidForm(): boolean {
    return this.entityForm.valid
      && this.isRolSelectorValidForm();
  }

  isEditionValidForm(): boolean {
    return this.entityForm.valid
      && this.isRolSelectorValidForm();
  }

  isRolSelectorValidForm(): boolean {
    if (this.rolSelector) {
      return this.rolSelector.isValid();
    }
    return false;
  }

  save() {
    if (this.isValidForm()) {
      this.loading.show();
      const entity: RolPermissionVM = Object.assign({
        PermissionType: PermissionType.ENDPOINT,
        Route: '',
        Roles: this.rolSelector.getSelectedCodes().toString(),
        RolCodes: this.rolSelector.getSelectedCodes(),
        AuthorizationRequired: false,
      }, this.entityForm.value);

      this.permissionService.insert(entity)
        .subscribe((response: RolPermissionVM) => {
          if (response) {
            response.Roles = this.rolService.getRolNames(response.RolCodes);
            this.grid.addRow(response);
            this.cancel();
            this.loading.hide();
          }
        }, (err) => {
          this.loading.hide();
        });
    }
  }

  cancel() {
    this.rolSelector.reset();
    this.initForm();
    this.setFormVisibility();
  }

  select(value: RolPermissionVM) {
    this.permission = value;
    this.entityForm.setValue({
      Code: this.permission.Code,
      Name: this.permission.Name,
      Method: this.permission.Method,
    });
    this.rolSelector.setSelectedCodes(this.permission.RolCodes);
    this.isEdition = true;
    this.setFormVisibility();
    setTimeout(() => {
      this.name.nativeElement.focus();
      this.name.nativeElement.select();
    }, 0);
  }

  update() {
    if (this.isEditionValidForm()) {
      this.loading.show();
      const entity: RolPermissionVM = Object.assign({
        UUID: this.permission.UUID,
        PermissionType: PermissionType.ENDPOINT,
        Route: '',
        Roles: this.rolSelector.getSelectedCodes().toString(),
        RolCodes: this.rolSelector.getSelectedCodes(),
        AuthorizationRequired: false,
      }, this.entityForm.value);
      this.permissionService.update(entity)
        .subscribe((response: RolPermissionVM) => {
          if (response) {
            response.Roles = this.rolService.getRolNames(response.RolCodes);
            this.grid.updateRowByUUID(response);
            this.cancel();
            this.loading.hide();
          }
        }, (err) => {
          this.loading.hide();
        });
    }
  }

  

}
